/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable complexity */

import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData} from 'modules/product-card/selectors';
import {useProductResultPrice} from 'hooks/product/useProductResultPrice';
import {useReviewsMeta} from 'modules/product-card/hooks/useReviewsMeta';
import Head from 'next/head';

interface IMarkingProps {
    url: string;
}

export const ProductSchema = (props: IMarkingProps) => {
    const productData = useAppSelector(selectProductData);
    const resultPrice = useProductResultPrice(productData);
    const {worstRating, reviewRating, bestRating, total} = useReviewsMeta(productData?.ratings);

    const normalizedPrice = resultPrice
        ?.replace(/[^\d.,]/gu, '')
        .replace(/\s/gu, '')
        .replace(',', '.')
        .trim();

    const jsonLd: Record<string, any> = {
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: productData?.title || undefined,
        sku: productData?.id || undefined,
        description: productData?.title || undefined,
        url: props.url,
        image: productData?.media?.imagePreview || undefined,
        category: productData?.catalogOriginalName || undefined,
        brand: productData?.brand?.manufacturer?.translate
            ? {'@type': 'Brand', name: productData.brand.manufacturer.translate}
            : undefined,
        offers: normalizedPrice
            ? {
                  '@type': 'Offer',
                  price: normalizedPrice,
                  priceCurrency: 'RUB',
                  availability:
                      productData?.canBuy || productData?.canReserve
                          ? 'https://schema.org/InStock'
                          : 'https://schema.org/PreOrder',
              }
            : undefined,
        aggregateRating:
            'undefined' !== typeof reviewRating || 'undefined' !== typeof total?.assessmentsCount
                ? {
                      '@type': 'AggregateRating',
                      worstRating: 'undefined' !== typeof worstRating ? worstRating : undefined,
                      bestRating: 'undefined' !== typeof bestRating ? bestRating : undefined,
                      ratingValue: 'undefined' !== typeof reviewRating ? reviewRating : undefined,
                      ratingCount: 'undefined' !== typeof total?.assessmentsCount ? total.assessmentsCount : undefined,
                  }
                : undefined,
    };

    return (
        <Head>
            <script type={'application/ld+json'} dangerouslySetInnerHTML={{__html: JSON.stringify(jsonLd)}} />
        </Head>
    );
};
